export default __webpack_public_path__ + "static/media/Yogesh_Resume.08ddd4e2.pdf";